import LogPreviewItem from './LogPreviewItem';

export default LogPreviewItem;
